module.exports = __webpack_public_path__ + "img/Picture2.bdd2e384.png";